module.exports = __webpack_public_path__ + "img/19_67.9e56df5c.png";